import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import maplibregl from "maplibre-gl";
import AWS from "aws-sdk";
import { Amplify, Storage, Auth } from "aws-amplify";
import AmplifyVue from "@aws-amplify/ui-vue";
import awsconfig from "./aws-exports";
import "maplibre-gl/dist/maplibre-gl.css";

Amplify.configure(awsconfig);

createApp(App)
  .use(router)
  .use(store)
  .use(AWS)
  .use(maplibregl)
  .use(Storage)
  .use(Auth)
  .use(Amplify)
  .use(AmplifyVue)
  .mount("#app");
